export type Id = string;

export interface Entity {
  id: Id;
  createdAt?: Date;
  updatedAt?: Date;
  deleted?: boolean;
}

export interface Address {
  address: string;
  city: string;
  zipCode: string;
  province: string;
}

export const REST_TEAM = 'REST';
